import { createSelector } from 'reselect'
import { groupBy, sum } from 'lib/array/arrayUtils'
import getMerchandiseItemViews from '../itemViews/getMerchandiseItemViews'
import { getMerchandiseVariantOptionText } from 'components/Merchandise/merchandiseUtils'
import { customPriceBreakdownTitle } from 'checkout/constants/priceBreakdownTitles'
import { getCurrentIntl } from 'i18n/util/currentIntl'

const getMerchandiseBreakdownView = createSelector(
  (state: App.State) => getMerchandiseItemViews(state),
  (itemView): App.WithDataStatus<Array<App.Checkout.PriceBreakdownView>> => {
    const ticketCount = itemView.data.length
    if (ticketCount === 0) {
      return {
        hasRequiredData: true,
        data: [],
      }
    }

    const intl = getCurrentIntl()
    const uniqueVariants = groupBy(itemView.data, data => data.variant.id)

    return {
      data: uniqueVariants.values().map((views): App.Checkout.PriceBreakdownView => ({
        title: customPriceBreakdownTitle(views[0].title),
        alwaysShowItemPrice: true,
        additionalInfoText: [
          getMerchandiseVariantOptionText(views[0].variant),
          intl.formatMessage(
            {
              id: 'EueTG8wyWyADfWhfctSv',
              defaultMessage: 'Qty: {count}',
              description: 'Quantity label for merchandise items in checkout breakdown',
            },
            { count: views.length },
          ),
        ],
        price: sum(views, view => view.totals.price),
        memberPrice: 0,
        itemsAlwaysVisible: true,
        items: views.map(view => ({
          itemId: view.item.itemId,
          title: view.title,
          itemType: 'merchandise',
          additionalInfo: [],
          additionalElements: [],
          price: view.totals.price,
          memberPrice: view.totals.memberPrice,
        })),
      })).toArray(),
      hasRequiredData: itemView.hasRequiredData,
    }
  },
)

export default getMerchandiseBreakdownView
